import { useNavigate } from 'react-router-dom';
import { Button } from 'Views/Components/Button/Button';
import * as React from 'react';
import Icon from '../Icon/Icon';
import useDeviceDetect from 'Hooks/useDeviceDetect';
import { trackStartGuidedBooking } from 'Util/_HumanWritten/Analytics/analyticsEvents';
import { TabSelected } from '../BookingWizard/FerryTripBookingWizard/BookingWizardTypes';
import { FormattedMessage } from 'react-intl';

export interface PassengerBookingButtonProps {
	onSearch: (type: TabSelected) => void;
}

export function PassengerBookingButton({ onSearch }: PassengerBookingButtonProps) {
	const navigate = useNavigate();
	const { isMobile } = useDeviceDetect();

	const onPassengerClick = () => {
		trackStartGuidedBooking('walk_on');
		onSearch('passenger');

		if (isMobile) {
			navigate('/booking-wizard?type=passenger');
		} else {
			navigate('/home/search?type=passenger');
		}
	};

	const passengerIcon = <Icon name="person" classname="passenger__icon" useMaterialIcons />;

	return (
		<Button
			key="passenger-booking-button"
			className="booking-type__button hide-underline`"
			onClick={onPassengerClick}
		>
			<h5>
				{passengerIcon}
				<FormattedMessage id="passenger__name__label" defaultMessage="Walk-on" />
			</h5>
		</Button>
	);
}
